import type { ProductImageEntry } from "./types";

export const ANALYTICS_WORKSPACE_CATALOGUE: readonly ProductImageEntry[] = [
  {
    id: "analytics.workspace-table",
    module: "Rapporter",
    area: "solution",
    opens: "Rapporter → Enhet och datum → daglig analystabell",
    setup: [
      "Öppna Rapporter för den publicerade Nacka CAIRE-källan",
      "Välj Nacka CAIRE och perioden 5–17 oktober 2026 i verktygsraden",
      "Välj Behov i nyckeltalen och visa den dagliga tabellen",
    ],
    scenario: "S1",
    visual: { variant: 0 },
    text: {
      sv: {
        alt: "Daglig analystabell för en enhet, 5–17 oktober 2026",
        shows:
          "Se publicerade dagliga mått för den valda enheten och perioden.",
        proves:
          "Tabellrader och besöksbehov kommer från Rapporter för den valda enhetens publicerade underlag.",
      },
      en: {
        alt: "Daily analytics table for one unit, 5–17 October 2026",
        shows:
          "View published daily measures for the selected service area and period.",
        proves:
          "The rows and visit-demand values come from Reports for the selected service area's published data.",
      },
    },
    use: ["pages/Plattform.tsx"],
  },
  {
    id: "analytics.workspace-trend",
    module: "Rapporter",
    area: "solution",
    opens: "Rapporter → Enhet och datum → Dagligt underlag",
    setup: [
      "Öppna Rapporter för den publicerade Nacka CAIRE-källan",
      "Välj Nacka CAIRE och perioden 5–17 oktober 2026 i verktygsraden",
      "Välj Behov i nyckeltalen och visa trenddiagrammet",
    ],
    scenario: "S1",
    visual: { variant: 0 },
    text: {
      sv: {
        alt: "Dagligt diagram över besöksbehov för en enhet, 5–17 oktober 2026",
        shows:
          "Följ det publicerade besöksbehovet dag för dag för den valda enheten.",
        proves:
          "Staplar och datum kommer från Rapporter för den valda enhetens publicerade underlag.",
      },
      en: {
        alt: "Daily visit-demand chart for one unit, 5–17 October 2026",
        shows:
          "Follow published visit demand by day for the selected service area.",
        proves:
          "The bars and dates come from Reports for the selected service area's published data.",
      },
    },
    use: ["pages/Plattform.tsx"],
  },
  {
    id: "analytics.workspace-compare-units",
    module: "Rapporter",
    area: "solution",
    opens: "Rapporter → Jämför (två enheter)",
    setup: [
      "Öppna Rapporter för Nacka CAIRE och välj kortet Jämför",
      "A: Nacka CAIRE, schemat 5–11 oktober 2026",
      "B: Nacka Norra, schemat 5–11 oktober 2026",
    ],
    scenario: "S1",
    visual: { variant: 0 },
    text: {
      sv: {
        alt: "Jämförelse av publicerat analysunderlag för två enheter, 5–11 oktober 2026",
        shows:
          "Jämför två urval med samma period och se skillnaden mellan B och A.",
        proves:
          "Rapporter visar skillnader mellan två enheters publicerade underlag när perioden och underlagets ursprung är jämförbara.",
      },
      en: {
        alt: "Comparison of published analytics evidence for two service areas, 5–11 October 2026",
        shows:
          "Compare two selections over the same period and see the difference from A to B.",
        proves:
          "Reports compares two service areas' published evidence when the period and source provenance are compatible.",
      },
    },
    use: ["pages/Plattform.tsx"],
  },
  {
    id: "analytics.workspace.source-receipt",
    module: "Rapporter · underlag",
    area: "solution",
    opens:
      "Rapporter → Varför ser det ut så? → Underlag och rekommenderade granskningar",
    setup: [
      "Välj publicerade Nacka CAIRE och perioden 5–17 oktober 2026",
      "Kontrollera källkortets exakta schema- och lösningslänkar",
      "Visa underlagsstatus, ursprung, period och täckning utan att öppna export",
    ],
    scenario: "S1",
    visual: { variant: 0 },
    text: {
      sv: {
        alt: "Publicerat analysunderlag med källperiod, status och täckning",
        shows:
          "Se vilket publicerat schema siffrorna kommer från och vilka enhetsdagar som har underlag.",
        proves:
          "Källkortet binder analysen till det valda sparade schemat och resultatet. Ursprung, status och täckning hjälper planeraren att granska underlaget utan att anta någon förbättring.",
      },
      en: {
        alt: "Published analytics evidence with source period, status and coverage",
        shows:
          "See which published schedule supplies the figures and which service-area days have evidence.",
        proves:
          "The source card binds the analysis to the selected saved schedule and result. Provenance, status and coverage help the planner review the evidence without assuming an improvement.",
      },
    },
    use: ["pages/Plattform.tsx"],
  },
  {
    id: "analytics.workspace.metric-definitions",
    module: "Rapporter · måttdefinitioner",
    area: "solution",
    opens: "Rapporter → Varför ser det ut så? → Måttdefinitioner",
    setup: [
      "Välj publicerade Nacka CAIRE och perioden 5–17 oktober 2026",
      "Kontrollera positivt besöksbehov och det valda publicerade källkortet",
      "Expandera Måttdefinitioner och visa definitioner samt datumregeln",
    ],
    scenario: "S1",
    visual: { variant: 0 },
    text: {
      sv: {
        alt: "Expanderade måttdefinitioner och datumregler i Rapporter",
        shows:
          "Läs vad analysens mått betyder och hur besök och arbetspass hänförs till datum.",
        proves:
          "Definitionerna hör till måtten i det aktuella analysurvalet. Planeraren kan tolka tid och behov med den uttryckliga datumregeln och se när underlag saknas.",
      },
      en: {
        alt: "Expanded metric definitions and date rules in Reports",
        shows:
          "Read what the analytics measures mean and how visits and shifts are attributed to dates.",
        proves:
          "Definitions belong to the measures in the current analytics selection. The planner can interpret time and demand with the explicit date rule and see when evidence is unavailable.",
      },
    },
    use: ["pages/Plattform.tsx"],
  },
];
